import BaseStore from "../base/BaseStore";
import { ImageActionType, ActionInterface } from "../constant/ActionConstant"
import AppDispatcher from "../dispatcher/AppDispatcher";

class ImageStore extends BaseStore {
    private _imagesUrl: string[]


    constructor() {
        super();
        this._imagesUrl = [];
    }

    public get images(): string[] {
        return this._imagesUrl;
    }

    addImage(url: string) {
        this._imagesUrl.push(url);
        this.emitChange();
    }

}

const storeActions = (store: ImageStore) => {
    return (action: ActionInterface) => {
        switch(action.type) {
            case ImageActionType.ADD_IMAGE_URL:
                store.addImage(action.data);
                break;
            
            default:
                break;
        }
    };
}

const ImageStoreInstance = new ImageStore();
ImageStoreInstance.dispatchToken = AppDispatcher.register(storeActions(ImageStoreInstance) as (payload: unknown) => void);

export default ImageStoreInstance;
export const store = ImageStore;
export const actions = storeActions;